// extracted by mini-css-extract-plugin
export var addButton = "_p6-0";
export var border = "_p6-8";
export var check = "_p6-h";
export var danger = "_p6-6";
export var dropdownContainer = "_p6-1";
export var editModalBody = "_p6-j";
export var footerContainer = "_p6-i";
export var fullWidth = "_p6-a";
export var hide = "_p6-9";
export var icon = "_p6-3";
export var input = "_p6-7";
export var inputFlex = "_p6-b";
export var inputWrapper = "_p6-c";
export var manualFocus = "_p6-5";
export var optionButton = "_p6-4";
export var pillWrapper = "_p6-e";
export var pointer = "_p6-2";
export var showOverflow = "_p6-f";
export var tagsFlex = "_p6-d";
export var xButton = "_p6-g";